export default __webpack_public_path__ + "static/media/plotigo-logo.ff2b2242.svg";